import * as portalApi from '../api/portal';
import { KeyedAsyncCache } from './asyncCache';

const farmerDashboardCache = new KeyedAsyncCache<portalApi.BackendFarmerDashboard | null>(
  (farmerId) => portalApi.getFarmerDashboard(farmerId),
  null,
  'portal:farmerDashboard',
);
const htxDashboardCache = new KeyedAsyncCache<portalApi.BackendHtxDashboard | null>(
  (htxId) => portalApi.getHtxDashboard(htxId),
  null,
  'portal:htxDashboard',
);

export function getFarmerDashboard(farmerId?: string): portalApi.BackendFarmerDashboard | null {
  if (!farmerId) return null;
  return farmerDashboardCache.get(farmerId);
}

export function getHtxDashboard(htxId?: string): portalApi.BackendHtxDashboard | null {
  if (!htxId) return null;
  return htxDashboardCache.get(htxId);
}
